import { computed, observable } from 'mobx';
import { Api } from '../../api/Api';
import { MealOutDto } from '../../api/generated';

import { IDiaryPageItem } from '../DiaryPageItem';

export class MealDiaryPageItem implements IDiaryPageItem {

    public readonly type = 'meal';

    @observable private _loading: boolean = false;
    @observable private _thumbnailUrl: string;

    private readonly _meal: MealOutDto;

    constructor(api: Api, meal: MealOutDto) {
      this._meal = meal;
      if (this.hasThumbnail) {
        this._loading = true;
        api.avatar(meal.imageThumbnail!.id!)
          .then(url => {
            this._loading = false;
            this._thumbnailUrl = url;
          }).catch(reason => {
            this._loading = false;
          });
      }
    }

    @computed get id() {
      return this._meal.id!;
    }

    @computed get loading() {
      return this._loading;
    }

    @computed public get description() {
      return this._meal.description;
    }

    @computed public get date() {
      return this._meal.zonedTimestamp;
    }

    @computed public get hasThumbnail() {
      return Boolean(this._meal.imageThumbnail);
    }

    @computed public get thumbnailUrl() {
      return this._thumbnailUrl;
    }

  }


// WEBPACK FOOTER //
// ./src/diary/meal/MealDiaryPageItem.ts